module.exports = __webpack_public_path__ + "static/media/steel-construction.5fd22ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/steel-construction.png
// module id = 127
// module chunks = 0